import CryptoJS from 'crypto-js';

export const convertLanguage = {"hib":"hi","de":"de","ru":"ru","fi":"fi","pt":"pt","bg":"bg","fr":"fr","zh-CN":"zh-CN","vib":"vi","itb":"it","elb":"el","sv":"sv","ko":"ko","zh-TW":"zh-TW","slb":"sl","en":"en","thb":"th","et":"et","cs":"cs","ar":"ar","hub":"hu","esb":"es","ja":"ja","pl":"pl","ro":"ro","da":"da","nl":"nl"}
export const changeByte = (byte: number) => {
    let size = "";
    if (byte < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = `${byte.toFixed(2)}B`;
    } else if (byte < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = `${(byte / 1024).toFixed(2)}KB`;
    } else if (byte < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = `${(byte / (1024 * 1024)).toFixed(2)}MB`;
    } else {
        // 其他转化成GB
        size = `${(byte / (1024 * 1024 * 1024)).toFixed(2)}GB`;
    }

    const sizeStr = `${size}`; // 转成字符串
    const index = sizeStr.indexOf("."); // 获取小数点处的索引
    const dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
    // eslint-disable-next-line eqeqeq
    if (dou == "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
};

export const getReplaceByString = (string: string, replaceStr: string) => {
    const oldString = string
    // @ts-ignore
    const newString = oldString.replace(replaceStr, "")
    return newString;
};

export const getSliceByString = (string: string, string1: string, string2: string) => {
    const startIndex = string.indexOf(string1); // 查找起始位置索引
    const endIndex = string.lastIndexOf(string2); // 查找结束位置索引（加上1表示包含最后一个字符）
    if (startIndex >= 0 &&  endIndex >= 0) {
        const result = string.substring((startIndex + 1), endIndex); // 提取子字符串
        return result;
    }
    return "";
};


export const getSliceByIndex = (string: string, string1: string) => {
    const endIndex = string.indexOf(string1); // 查找起始位置索引
    if (endIndex >= 0) {
        const result = string.substring(0, endIndex); // 提取子字符串
        return result;
    }
    return "";
};

export const formatDate = (time, type, add?:any) => {
    let timestamp = 0;
    if (typeof time === 'string') {
        time = time.replace('T', ' ').replace('.000+0000', '')
        const date = new Date(time);
        // 如果解析失败，尝试使用 Date.parse
        if (isNaN(date.getTime())) {
            const parsedTime = Date.parse(time);
            if (!isNaN(parsedTime)) {
                timestamp = parsedTime;
            } else {
                console.warn('Invalid date format:', time);
                timestamp = Date.now(); // 使用当前时间作为默认值
            }
        } else {
            timestamp = date.getTime();
        }
        // 转换成北京时间，utc时间+8h
        if (add) {
            timestamp = timestamp / 1000
            timestamp = timestamp + 60 * 60 * 8
            timestamp = timestamp * 1000
        }
    } else {
        if (typeof time === 'number'){
            timestamp = time;
        } else if (!time) {
            timestamp = Date.now(); // 使用当前时间
            // timestamp = new Date().valueOf();
        } else if (typeof time === 'object') {
            timestamp = time.getTime();
        }
    }

    let dateStr = '';
    var beijingDate = new Date(timestamp)
    let YY = beijingDate.getFullYear(),
        MM: string | number = beijingDate.getMonth() + 1,
        DD: string | number = beijingDate.getDate(),
        hh: string | number = beijingDate.getHours(),
        mm: string | number = beijingDate.getMinutes(),
        ss: string | number = beijingDate.getSeconds();
    MM = MM < 10 ? ("0" + MM) : MM;
    DD = DD < 10 ? ("0" + DD) : DD;
    hh = hh < 10 ? ("0" + hh) : hh;
    mm = mm < 10 ? ("0" + mm) : mm;
    ss = ss < 10 ? ("0" + ss) : ss;

    switch (type) {
        case 'MM-DD hh:mm':
            dateStr = MM + '-' + DD + ' ' + hh + ':' + mm;
            break;
        case 'MM-DD':
            dateStr = MM + '-' + DD;
            break;
        case 'hh:mm':
            dateStr = hh + ':' + mm;
            break;
        case 'YY-MM-DD':
            dateStr = YY + '-' + MM + '-' + DD
            break;
        case 'MM-DD hh:mm:ss':
            dateStr = MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss;
            break;
        case 'YYMMDD':
            dateStr = YY + '' + MM + '' + DD;
            break;
        case 'YY':
            dateStr = YY + '';
            break;
        case 'YY-MM':
            dateStr = YY + '-' + MM;
            break;
        default:
            dateStr = YY + '-' + MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss;
    }
    return dateStr;
};

export const getCurrentTime = () => {
    const date = new Date();
    const timestamp = date.getTime()
    return timestamp
}

export const formatSecond = (second: number) => {
    // const days = Math.floor(second / 86400);
    // const hours = Math.floor((second % 86400) / 3600);
    const minutes = Math.floor(((second % 86400) % 3600) / 60);
    const seconds = Math.floor(((second % 86400) % 3600) % 60);
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
}

export function findKey (obj,value, compare = (a, b) => a === b) {
    return Object.keys(obj).find(k => compare(obj[k], value))
}

export function containsSubstring(str, substring) {
    // 使用正则表达式创建一个RegExp对象
    const regex = new RegExp(substring);
    // 使用test方法检查是否匹配
    return regex.test(str);
}

export function hideReverseString(str, index) {
    // 创建一个正则表达式，匹配从开始到指定下标之前的所有字符
    const regex = new RegExp('.{' + index + '}', 'g');
    // 使用replace方法将匹配的字符替换为星号
    return str.replace(regex, '*'.repeat(index));
}

export function maskString(str) {
    if (str && str.length > 0) {
        // 移除非数字字符
        const numberOnly = str.replace(/\D/g, '');
        // 使用正则表达式替换中间部分为星号
        return numberOnly.replace(/^(.{4})(.*)(.{4})$/, '$1****$3');
    }
    return ""
}
// 判断是否是在移动设备上
export function isMobileOrTablet ()  {
    const userAgent = navigator.userAgent;
    // 检查是否是手机
    const isMobile = /Mobi|Android/i.test(userAgent);
    // 检查是否是平板
    const isTablet = /iPad|Android(?!.*Mobile)/i.test(userAgent);
    const widthMedia = window.matchMedia("(max-width: 1024px)").matches; // 根据需要调整宽度
    // const widthMedia = window.matchMedia("(max-width: 992px)").matches; // 根据需要调整宽度
    const ua = navigator.userAgent.toLowerCase()
    const isWxH5 = /micromessenger/.test(ua);

    return isMobile || isTablet || widthMedia || isWxH5;
}

// 根据媒体查询判断是否是移动设备
export function  ismatchMedia  ()  {
    return window.matchMedia("(max-width: 992px)").matches; // 根据需要调整宽度
    // return window.matchMedia("(max-width: 1024px)").matches; // 根据需要调整宽度
}

export function isMobileSafari() {
  const ua = navigator.userAgent.toLowerCase();
  console.log('navigator.platform', navigator)
  // 支持更多 iOS 浏览器环境（微信、Chrome、WebView）
  const isIOS =
    /iPhone|iPad|iPod|iOS|iPhone OS|Macintosh/.test(ua) ||
    (navigator.maxTouchPoints > 2 && /Mac/.test(navigator.platform));

  // 判断是否是 Safari 浏览器
  const isSafari = /version\/[\d\.]+.*safari/.test(ua);
    
  return isIOS && isSafari;
}


// 给下面方法使用， 读取加密文件内容并且解密
function decryptData(ciphertext, secretKey) {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
}

let sensitiveWords = [];
export async function getSensitiveThesaurus() {
    // 这个 密钥，是针对， sensitive1.txt 这个文件加密时的固定密钥，
    const secretKey = '1520d295d82281cb4671fbe09b2d36ec66ce74f8da8d44a06142e093791f8a3c';
    const fileUrl = '/sensitive.txt'; 
    let fileArray = [];
    try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
            throw new Error('文件读取失败');
        }
        const content = await response.text();
        const decryptedFromFile = decryptData(content, secretKey);
        fileArray = decryptedFromFile.split(",").map((line) => line.trim());

        // console.log('文件内容:', content, fileArray);
    } catch (error) {
        console.error('读取文件时出错:', error);
    }
    sensitiveWords = fileArray;
}

export const filterSensitiveWords = (text: string): string => {
    let filteredText = text;
    sensitiveWords.forEach((word) => {
        const regex = new RegExp(word, 'g'); // 全局匹配
        filteredText = filteredText.replace(regex, '*'.repeat(word.length)); // 替换为相同长度的 *
    });
    return filteredText;
};

export const debounce = <T extends (...args: any[]) => void>(fn: T, delay: number) => {
    let timeout: NodeJS.Timeout | null = null;
    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
};
export const simplifyFileName = (fileName: string): string => {
    if (!fileName) return 'file';
  
    // 替换 Safari 不支持的字符：控制字符、路径分隔符、冒号等
    let simplifiedName = fileName;
  
    // 替换路径分隔符 / 和 \ 为 _
    simplifiedName = simplifiedName.replace(/[\/\\]/g, '_');
  
    // 替换冒号 : 为 _（macOS 中 : 会被自动转成 _）
    simplifiedName = simplifiedName.replace(/:/g, '_');
  
    // 替换控制字符（ASCII 0x00–0x1F 和 0x7F）为空字符串
    simplifiedName = simplifiedName.replace(/[\x00-\x1F\x7F]/g, '');
  
    // 替换多个空白符为一个下划线（仅当需要统一命名风格时使用）
    simplifiedName = simplifiedName.replace(/\s+/g, '_');
  
    // 替换多个连续的 _ 为一个 _
    simplifiedName = simplifiedName.replace(/_+/g, '_');
  
    // 去除开头和结尾的 _（不影响核心内容）
    simplifiedName = simplifiedName.replace(/^_|_$/g, '');
  
    // 如果最终文件名为空，则返回默认名称
    if (simplifiedName.length === 0) {
      simplifiedName = 'file';
    }
  
    return simplifiedName;
  };
// import Toast from "@/components/Toast.vue";
//
// const div = document.createElement("div");
// div.setAttribute("class", "toast");
// document.body.appendChild(div);
//
// let time = null;
// export const toast = (text, duration: number = 1500) => {
//     const NODE = createVNode(Toast, { text });
//     render(NODE, div);
//     clearTimeout(time);
//     time = setTimeout(() => {
//         render(null, div);
//     }, duration);
// };
